
class MiscellanyCategory {
    public id: string;
    public name: string;
    public description: string;
    public price: number;
    public amount?: number;
    public purchasePrice?: number;

    constructor(id: string, name: string, description: string, price: number, purchasePrice?: number) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.price = price;
        this.purchasePrice = purchasePrice;
    }

}

export default MiscellanyCategory;